import styled from 'styled-components';

export const RadioWrapper = styled.div`
  max-width: 350px;
  width: 350px;
  margin: 0 auto;
`;
